<script setup lang="ts">
import { RouterView, useRoute, useRouter } from "vue-router";
// @ts-ignore
import LINESeedJP_OTF_Bd from "../../src/assets/fonts/LINESeedJP_OTF_Bd.woff2";
// @ts-ignore
import LINESeedJP_OTF_Eb from "../../src/assets/fonts/LINESeedJP_OTF_Eb.woff2";
import FontFaceObserver from "fontfaceobserver";
import { computed, ref } from "vue";
import AdminNotify from "../../src/component/AdminNotify.vue";
import AdminLoading from "../../src/component/AdminLoading.vue";

// フォントのオブザーバーを作成
const font = new FontFaceObserver("LINESeedJPStd");

// フォントがロードされたら実行される
font.load().then(
  () => {
    document.documentElement.classList.add("fonts-loaded");
  },
  () => {
    console.error("LINESeedJPStd font could not be loaded after 3 seconds.");
  }
);

const style = document.createElement("style");
style.textContent = `
  @font-face {
    font-family: 'LINESeedJPStd';
    src: url('${LINESeedJP_OTF_Bd}') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap; /* ロード中はフォールバックフォントを使用 */
  }
  @font-face {
    font-family: 'LINESeedJPStd';
    src: url('${LINESeedJP_OTF_Eb}') format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap; /* ロード中はフォールバックフォントを使用 */
  }
  @font-face {
    font-family: "LINE Seed JP_TTF";
    src: url('${LINESeedJP_OTF_Bd}') format('woff2');
    font-weight: bold;
    font-style: normal;
    font-display: swap; /* ロード中はフォールバックフォントを使用 */
  }
  @font-face {
    font-family: "LINE Seed JP_TTF";
    src: url('${LINESeedJP_OTF_Eb}') format('woff2');
    font-weight: 800;
    font-style: normal;
    font-display: swap; /* ロード中はフォールバックフォントを使用 */
  }
`;
document.head.append(style);
</script>

<script lang="ts">
const loading = ref(false);

let loadingCounter = 0;

export const setLoading = (value: boolean) => {
  if (value) {
    loadingCounter++;
  } else {
    if (loadingCounter > 0) {
      loadingCounter--;
    }
  }
  if (loadingCounter > 0) {
    const appElm = document.querySelector("#app") as HTMLDivElement;
    if (appElm) {
      appElm.style.overflow = "hidden";
    }
    loading.value = true;
  }
  if (loadingCounter === 0) {
    const appElm = document.querySelector("#app") as HTMLDivElement;
    if (appElm) {
      appElm.style.overflow = "unset";
    }
    loading.value = false;
  }
};

const notify = ref();
export const showNotify = (success: boolean, title: string, body: string) => {
  notify.value.show(success, title, body);
};
</script>
<template>
  <AdminLoading :loading="loading" full-screen />
  <AdminNotify ref="notify" />
  <div class="bg-base text-main-text relative flex flex-row">
    <RouterView />
  </div>
</template>
<style lang="scss">
:root {
  --transition-duration: 0s;
}

.overlay {
  display: none;
  background-color: transparent;
}

html,
body,
#app {
  height: 100%;
}

body {
  font-weight: normal;
  line-height: 1.6;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 16px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "pkna";
  color: var(--color-main-text);
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  touch-action: manipulation;
  overscroll-behavior-y: none;
}

.fonts-loaded body {
  font-family: "LINESeedJPStd", sans-serif;
}

.overflow-y-auto {
  overflow-y: auto;
  scrollbar-gutter: stable;
}
</style>
